import { ApiProperty } from "@nestjs/swagger";
import { ItemtypeEnum } from "@project-management-system/shared-models";
import { StyleComboDto } from "./style-combo-dto";

export class BomMasterDto {
  @ApiProperty()
  itemName: string;

  @ApiProperty()
  description: string;

  @ApiProperty()
  imCode: string;
  @ApiProperty()
  bomId?: number;

  @ApiProperty()
  sequence?: number;

  @ApiProperty()
  vendorName?: string;

  @ApiProperty()
  orderForm?: string;
  constructor(
    itemName: string,
    description: string,
    imCode: string,
    bomId?: number,
    sequence?: number,
    vendorName?: string,
    orderForm?: string
  ) {
    this.itemName = itemName;
    this.description = description;
    this.imCode = imCode;
    this.bomId = bomId;
    this.sequence = sequence;
    this.vendorName = vendorName;
    this.orderForm = orderForm;
  }
}
